import React from 'react';
import { Outlet } from "react-router-dom";
import Header from '../Home/Header';
import Footer from './Footer';
import WhatsappIcon from '../../pages/WhatsappIcon';

function Mainlayout() {
  return (
    <>
    <Header />
    <Outlet />
    <Footer />
    <WhatsappIcon />
    </>
  )
}

export default Mainlayout